const projectsListReducer = (state = {
    loading:false,
    projectsList:[],
    totalRecords:0,
}, action) => {
    switch (action.type) {
        case "FETCH_PROJECTS":
            return { ...state ,loading:true,projectsList:[],totalRecords:0}
        case "RECEIVE_PROJECTS":
            return {...state, projectsList:[...action.payload.projects],loading:false,totalRecords:action.payload.totalRecords}
        case "ERROR_PROJECTS":
            return { ...state ,projectsList:[],loading:true,totalRecords:0}
        default:
            return { ...state }
    }
}

export default projectsListReducer;